import React, { useState } from 'react';
import styled from 'styled-components';

import doFetch from '../../../api/doFetch';
import Switch from '../../../components/Switch';
import ContentBoardStyled from '../../../components/ContentBoardStyled';
import StyledBoardHeader from '../../../components/StyledBoardHeader';
import EditAiSetting from './EditAiSetting';
import Seporator from './Seporator';

const Block = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-width: 340px;
  padding: 20px;
  font-size: 14px;
  color: #28283a;
  overflow: hidden;
  word-break: break-all;

  & .description {
    color: #677b8b;
    font-size: 10px;
    font-weight: 400;
    max-width: 232px;
    line-height: 1.4em;
  }

  & > .info {
    border-bottom: 1px solid rgba(40, 56, 144, 0.1);
    width: 100%;
    margin: 0 -20px 20px;
    padding: 0 20px 20px;
    & .label {
      color: #677b8b;
      font-size: 10px;
      font-weight: 700;
      width: fit-content;
      text-wrap: nowrap;
    }
    & .row {
      display: flex;
      flex-direction: row;
    }
    & .column {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    & .value {
      margin: 10px 0;
    }
  }
`;

const DealerAiSetting = ({ dealer, updateDealer }) => {
  const [isOpenModal, setIsOpenEditUserModal] = useState(false);
  const toggleModal = () => setIsOpenEditUserModal(!isOpenModal);

  const handlerChange = async (event) => {
    event.preventDefault();

    const commentScriptSettings = {
      ...(dealer.commentScriptSettings || {}),
      enabled: !dealer.commentScriptSettings?.enabled,
      regenerate: true
    };

    try {
      await doFetch(`/dealerships/${dealer.hmsId}/comment-setting`, {
        method: 'PUT',
        body: JSON.stringify({ setting: commentScriptSettings })
      });
      updateDealer({ commentScriptSettings });
    } catch (error) {
      alert(error);
    }
  };

  return (
    <ContentBoardStyled
      css={{
        minHeight: Boolean(dealer?.commentScriptSettings?.enabled) ? '298px' : '154px',
        marginLeft: 0,
        marginTop: 0
      }}
    >
      <StyledBoardHeader
        button={
          Boolean(dealer?.commentScriptSettings?.enabled)
            ? { name: 'Edit', handler: toggleModal }
            : null
        }
      >
        AI GENERATED COMMENTS
      </StyledBoardHeader>
      <Block>
        {Boolean(dealer?.commentScriptSettings?.enabled) && (
          <div className='info'>
            <div className='row'>
              <div className='column'>
                <div className='label'>Сharacter Limit</div>
                <div className='value'>{dealer.commentScriptSettings.character_limit}</div>
              </div>
            </div>
            <Seporator />
            <div className='row'>
              <div className='column'>
                <div className='label'>Options</div>
                <div className='value'>{dealer.commentScriptSettings.focus.options}</div>
              </div>
              <div className='column'>
                <div className='label'>Safety</div>
                <div className='value'>{dealer.commentScriptSettings.focus.safety}</div>
              </div>
              <div className='column'>
                <div className='label'>Awards</div>
                <div className='value'>{dealer.commentScriptSettings.focus.awards}</div>
              </div>
            </div>
          </div>
        )}
        <Switch
          label={
            Boolean(dealer?.commentScriptSettings?.enabled)
              ? 'Deactivate AI Generated Comments.'
              : 'Activate AI Generated Comments.'
          }
          checked={Boolean(dealer?.commentScriptSettings?.enabled)}
          onChange={handlerChange}
        />
        {!dealer?.commentScriptSettings?.enabled && (
          <p className='description'>
            By toggling on this feature you are activating custom comments generated by AI.
          </p>
        )}
      </Block>
      {Boolean(isOpenModal) && (
        <EditAiSetting
          dealer={dealer}
          isOpen={true}
          toggleHandler={toggleModal}
          updateDetails={updateDealer}
        />
      )}
    </ContentBoardStyled>
  );
};

export default DealerAiSetting;
